import type { InvoiceKindKey } from '~/data/schemas/invoice';

// Shared document-type enum for the manual upload/tagging flows. The former
// `AddManuallyDropdown` component (a SplitButtonSelect wrapper) was removed once
// the "Add to Property" dialog took over its role; this module now only hosts the
// enum, which is imported across the upload/tagging components.
// TODO: Does this declaration make sense here?
export enum UploadDocumentType {
  initial = 'Initial',
  invoice = 'Invoice',
  invoiceContinued = 'Invoice (Continued)',
  ticket = 'Ticket',
  ticketContinued = 'Ticket (Continued)',
  supportingData = 'Supporting Data',
  proposal = 'Proposal',
  proposalContinued = 'Proposal (Continued)',
  credit = 'Credit',
  certificate = 'Certificate',
  certificateContinued = 'Certificate (Continued)',
  inspectionReport = 'Inspection Report',
  inspectionReportContinued = 'Inspection Report (Continued)',
  violation = 'Violation',
}

export const invoiceKindToUploadDocumentType = {
  invoice: UploadDocumentType.invoice,
  proposal: UploadDocumentType.proposal,
  credit: UploadDocumentType.credit,
} as const satisfies Record<InvoiceKindKey, UploadDocumentType>;
